const validate = (values) => {
    const errors = {};
   
    if (!values.raffleName) {
        errors.raffleName = "Please select a raffle draw";
    }
    if (!values.rewardType) {
        errors.rewardType = "Reward type field cannot be empty. Please select a raffle draw";
    }
    if (!values.numberOfWinners) {
        errors.numberOfWinners = "Number of winners field cannot be empty. Please select a raffle draw";
    }
    if (!values.csv_file) {
        errors.csv_file = "Please upload the winners list";
    }
    return errors;
};

export default validate;
